export const projects = [
  {
    name: 'LinkedPin',
    description: 'AI-powered Chrome extension that summarizes LinkedIn posts. 50+ users.',
    tech: ['Java Spring Boot', 'AWS', 'PostgreSQL'],
    link: 'https://chromewebstore.google.com/detail/linkedpin/inmfbdikodcipdlbpdnobbceaklcjacc'
  },
  {
    name: 'Chess',
    description: 'Full chess game in C++ with checkmate, castling, and advanced OOP.',
    tech: ['C++', 'OOP', 'Algorithms'],
    link: 'https://github.com/Ossama-E/Chess'
  },
  {
    name: 'Sortify.AI',
    description: 'ML-powered real-time waste sorting app. Featured at DeerHacks 2023.',
    tech: ['Python', 'TensorFlow', 'ML'],
    link: 'https://github.com/Ossama-E/Sortify.AI'
  },
  {
    name: 'LCHints',
    description: 'AI-assisted LeetCode help platform using GPT-3.5.',
    tech: ['OpenAI', 'JavaScript', 'Node.js'],
    link: 'https://lchints-web.herokuapp.com/'
  },
  {
    name: 'NeighBoard',
    description: 'Community platform for sharing neighbourhood activities and reports.',
    tech: ['Vue.js', 'Firebase'],
    link: 'https://neighboard.netlify.app/#/'
  }
];
